import { config } from 'config';
import { createCustomSlice } from 'core/utils';
import orderBy from 'lodash/orderBy';
const { professionalStatus } = config;

const initialState = {
    busy: false,
    externalLogin: '',
    externalLoginError: '',
    hasErrors: false,
    list: [],
    loading: false,
    notificationResponse: '',
    registrationError: {},
    registrationErrorModal: false,
    saveLoading: false,
    selected: {}
};

const professionalSlice = createCustomSlice({
    initialState,
    name: 'professional',
    reducers: {
        setProfessionalList (state, { payload }) {
            state.list = orderBy(payload, [...(professionalStatus ? ['status'] : []), 'last_name', 'first_name'], ['asc', 'asc', 'asc']);
        }
    },
    saga: [
        'createProfessionalExternalLogin',
        'deleteProfessional',
        'getProfessional',
        'getProfessionalListing',
        'professionalSetEnabled',
        'saveProfessional',
        'sendProfessionalNotification'
    ]
});

export const professionalActions = professionalSlice.actions;

export default professionalSlice.reducer;
